<template>
  <v-row>
    <v-col cols="12" md="6">
      <gg-card-title class="pb-0 pt-0">{{ $route.meta.pageTitle }}</gg-card-title>
    </v-col>
    <v-col cols="12" md="6" class="text-md-right pb-2">
      <add-new-account />
    </v-col>
    <v-col cols="12">
      <services-table
        title="Hosting Plans"
        :items="allServicesList"
        :filters="filters"
        :search="search"
      >
      <template v-slot:header-actions>
        <g-g-filter
          offset-y
          left
          bottom
          :close-on-content-click="false"
          :items="filterItems"
          @change="filters = $event"
        ></g-g-filter>
        <div class="w-100" style="max-width: 440px">
          <services-search v-model="search" compact />
        </div>
      </template>
    </services-table>
    </v-col>
    <v-col cols="12">
      <services-table
        title="Shared With Me"
        :items="sharedServicesList"
        text
        :search="search"
        hide-icons
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import ServicesSearch from 'Components/Services/Hosting/ServicesPage/ServicesSearch'
import ServicesTable from 'Components/Services/Hosting/ServicesPage/ServicesTable'
import AddNewAccount from 'Components/Services/Hosting/ServicesPage/AddNewAccount'
import GGFilter from '@/components/Elements/GGFilter.vue'

export default {
  name: 'HostingServices',
  components: {
    ServicesTable,
    ServicesSearch,
    AddNewAccount,
    GGFilter,
  },
  data () {
    return {
      acceptedService: ['cpanel', 'whm', 'vserver', 'dserver', 'kvm'],
      search: '',
      loading: '',
      // filter settings
      filterItems: [
        { value: 'cpanel', label: 'Shared' },
        { value: 'whm', label: 'Reseller' },
        { value: 'vserver', label: 'VPS' },
        { value: 'dserver', label: 'Dedicated' },
      ],
      // active filters
      filters: [],
    }
  },
  computed: {
    ...mapGetters(['services']),
    servicesList () {
      return this.services
        .filter(service => this.acceptedService.includes(service.type))
        .map((el, index) => ({
          ...el,
          virtualId: `${el.id}-${index}`,
          searchable_name: `${el.domain} ${el.name}`
        }))
    },
    allServicesList () {
      const nonSharedServices = this.servicesList.filter(service => !service.sharedaccount && !service.sharedaccess)
      const sharedAccessServices = this.servicesList.filter(service => service.sharedaccess)

      return nonSharedServices.concat(sharedAccessServices)
    },
    sharedServicesList () {
      return this.servicesList.filter(service => service.sharedaccount)
    }
  },
}
</script>
